import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=d9f79082&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9f79082')) {
      api.createRecord('d9f79082', component.options)
    } else {
      api.reload('d9f79082', component.options)
    }
    module.hot.accept("./FooterBar.vue?vue&type=template&id=d9f79082&", function () {
      api.rerender('d9f79082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whatsapp/template/component/FooterBar.vue"
export default component.exports